module.exports = __webpack_public_path__ + "static/media/redo-disabled.2393b404.svg";